export default __webpack_public_path__ + "static/media/Postlogin-switch-card-banner.ecbd8d71.png";